import { render, staticRenderFns } from "./ClaimRewardDialogue.vue?vue&type=template&id=41ddcdd8&scoped=true"
import script from "./ClaimRewardDialogue.vue?vue&type=script&lang=js"
export * from "./ClaimRewardDialogue.vue?vue&type=script&lang=js"
import style0 from "./ClaimRewardDialogue.vue?vue&type=style&index=0&id=41ddcdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ddcdd8",
  null
  
)

export default component.exports